<template>
    <div class="content-text-container">
        <div class="conten-section">
            <p>At Charm-Vibe, we take your privacy seriously and are committed to protecting your personal data in accordance with the Privacy Act 1988 (Cth) and the Australian Privacy Principles (APPs).</p>
        </div>
        <div class="conten-section">
            <h3>1. What We Collect</h3>
            <p>- Name, email, DOB, and contact details</p>
            <p>- Optional: Profile images, medical consultation images</p>
            <p>- Device/browser data for analytics</p>
        </div>
        <div class="conten-section">
            <h3>2. How We Use Your Data</h3>
            <p>- To create and manage your account</p>
            <p>- To facilitate bookings and consultations</p>
            <p>- To personalise your experience</p>
            <p>- To ensure secure, ethical, and compliant content moderation</p>
        </div>
        <div class="conten-section">
            <h3>3. Image Privacy</h3>
            <p>Uploaded images are securely stored and never shared publicly without explicit consent. Screenshots are disabled on sensitive content areas.</p>
        </div>
        <div class="conten-section">
            <h3>4. Data Security</h3>
            <p>- Encrypted storage and secure servers</p>
            <p>- Access restricted to authorized staff only</p>
            <p>- Regular audits and privacy training</p>
        </div>
        <div class="conten-section">
            <h3>5. Cookies</h3>
            <p>We use cookies to understand platform usage and improve service. You may disable them in your browser.</p>
        </div>
        <div class="conten-section">
            <h3>6. Your Rights</h3>
            <p>- Request access, correction, or deletion of your data</p>
            <p>- Withdraw image consent at any time</p>
            <p>- Request removal of uploaded content</p>
        </div>
        <div class="conten-section">
            <h3>7. Third-Party Services</h3>
            <p>We may use verified payment processors and analytics tools. These services are bound by their own privacy obligations.</p>
        </div>
        <div class="conten-section">
            <h3>8. Changes to Policy</h3>
            <p>We may update this policy. The latest version will always be available on our site.</p>
        </div>
        <div class="conten-section">
            <h3>9. Contact Us</h3>
            <p>For any privacy-related concerns, email us.</p>
        </div>
    </div>
</template>
<script lang="ts" setup></script>
<style lang="scss" scoped>
.content-text-container{
    .conten-section{
        h3{
            color: #000000;
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: 24px; 
        }
        p{
            color: #000000;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 24px; 
            word-wrap: break-word;
        }

        .sub-item{
            text-indent: 12px;
        }
    }
}
</style>
